import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { Package } from "./package.model";
import { map } from "rxjs/operators";
import { PackageMapper } from "./package.mapper";

@Injectable()
export class PackageRepository {
  protected http = inject(HttpClient);

  public calculate(packageModel: Package): Observable<Package> {
    return this.http
      .post<Package>(
        `${environment.apiUrl}/package/calculate`,
        packageModel.getRequestParams(),
      )
      .pipe(map((response) => PackageMapper.map(response)));
  }
}
